<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="306px"
    :close-on-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="dateComputed"
        :label="$t('message.reviews.dateRange')"
        prepend-icon="icon-calendar"
        style="min-width:230px;"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      first-day-of-week="1"
      :locale="selectedLocale"
      color="primary"
      no-title
      scrollable
      range
      class="pa-2"
      :allowed-dates="disabledAfterToday"
    >
      <div class="custom-date">
        <div class="custom-date__fields">
          <v-text-field
            v-model="dateFrom"
            :label="$t('message.common.dateFrom')"
            :disabled="!editDates"
            class="custom-date__field"
            @keyup.enter="handleEditDatesBtn"
          ></v-text-field
          ><v-text-field
            v-model="dateTo"
            :label="$t('message.common.dateTo')"
            :disabled="!editDates"
            class="custom-date__field"
            @keyup.enter="handleEditDatesBtn"
          ></v-text-field>
          <v-btn icon color="primary" @click="handleEditDatesBtn">
            <v-icon>
              {{ editDates ? "icon-check" : "icon-edit" }}
            </v-icon>
          </v-btn>
        </div>
        <div class="custom-date__actions">
          <ui-button outlined transparent color="primary" @click="menu = false"
            >{{ $t("message.reviews.cancel") }}
          </ui-button>
          <v-spacer></v-spacer>
          <ui-button outlined transparent color="primary" @click="handleSubmit"
            >{{ $t("message.common.choose") }}
          </ui-button>
        </div>
      </div>
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment";
import { FORMAT } from "@/config/date-format";

export default {
  name: "ReviewBoosterDatePicker",
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      menu: null,
      date: null,
      dateFrom: null,
      dateTo: null,
      editDates: false
    };
  },
  computed: {
    selectedLocale() {
      return this.$store.state.settings.selectedLocale;
    },
    dateComputed() {
      const [dateFrom, dateTo] = this.value;
      if (dateFrom && dateTo) {
        return `${moment(dateFrom).format(FORMAT.DATE)} - ${moment(
          dateTo
        ).format(FORMAT.DATE)}`;
      }
      return "";
    }
  },
  created() {
    this.date = this.value;
    this.setDates();
  },
  methods: {
    disabledAfterToday(val) {
      const currentDate = moment().format(FORMAT.DATE);
      const compareDate = moment(val);

      return compareDate.isSameOrBefore(currentDate);
    },
    handleSubmit() {
      this.$emit("input", this.date);
      this.dateFrom = this.date[0];
      this.dateTo = this.date[1];
      this.menu = false;
    },
    handleEditDatesBtn() {
      if (this.editDates) {
        this.date = [this.dateFrom, this.dateTo];
      }
      this.editDates = !this.editDates;
    },
    handleDateChange() {
      this.setDates();
    },
    async setDates() {
      const [oldDateFrom, oldDateTo] = this.value;
      this.dateFrom = oldDateFrom;
      this.dateTo = oldDateTo;
      this.date = [this.dateFrom, this.dateTo];
    }
  },
  watch: {
    date([dateFrom, dateTo]) {
      this.dateFrom = dateFrom;
      this.dateTo = dateTo || dateFrom;
    }
  }
};
</script>
<style lang="scss">
.custom-date {
  width: 100%;
  border-top: 1px solid $gray-200;
  &__fields {
    display: flex;
    align-items: center;
    gap: $spacing;
  }

  &__field {
    flex-grow: 1;
  }

  &__actions {
    display: flex;
    justify-content: space-between;
  }
}
</style>
